import { defineStore } from 'pinia'
import { changePassword as changePasswordApi, getCurrentUser, login as loginApi, logout as logoutApi } from '@/api/auth'
import type { CurrentUser } from '@/api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as CurrentUser | null,
    initialized: false
  }),
  getters: {
    permissions: (state) => state.user?.permissions ?? [],
    isAuthenticated: (state) => Boolean(state.user),
    forcePasswordChange: (state) => Boolean(state.user?.force_password_change),
    displayName: (state) => state.user?.display_name || state.user?.username || '',
    hasPermission: (state) => (permission?: string) => {
      if (!permission) return true
      return state.user?.permissions?.includes(permission) ?? false
    },
    hasAnyPermission: (state) => (permissions: string[]) => {
      if (!permissions.length) return true
      return permissions.some((permission) => state.user?.permissions?.includes(permission))
    }
  },
  actions: {
    async login(username: string, password: string) {
      this.user = await loginApi({ username, password })
      this.initialized = true
    },
    async fetchCurrentUser() {
      try {
        this.user = await getCurrentUser()
      } catch {
        this.user = null
      } finally {
        this.initialized = true
      }
    },
    async logout() {
      try {
        await logoutApi()
      } finally {
        this.user = null
      }
    },
    async changePassword(oldPassword: string, newPassword: string) {
      await changePasswordApi({ old_password: oldPassword, new_password: newPassword })
      if (this.user) this.user.force_password_change = false
    }
  }
})
